export default __webpack_public_path__ + "static/media/september.b844c0b2.jpg";